import anime from 'animejs'
import { CLOSE_WITH_LOADER, CONTENT, LOAD_CONTENT, CLOSE_LOADED, CIRCLE, OPEN, CLOSE } from '../constants/animationConstants';

type AnimateType = 
  | typeof CLOSE_WITH_LOADER
  | typeof CLOSE_LOADED
  | typeof OPEN
  | typeof CLOSE

const animate = (animationItems: any, type: AnimateType): Promise<void> => {
  
  const loadContent = [...animationItems[LOAD_CONTENT]]
  const circle = [...animationItems[CIRCLE]]
  const content = [...animationItems[CONTENT]]
    

  switch(type) {
    case CLOSE_LOADED: {     
      return new Promise((resolve, reject) => {  
        anime({
          targets: loadContent,
          opacity: 0,
          duration: 250,
          easing: 'easeInOutExpo',
          complete: () => {
            anime({
              easing: 'easeInOutExpo',
              targets: circle,
              scale: 0,
              duration: 250,
              complete: () => {
                resolve()
              }
            })
          }
        })
      })
    }
    
    case CLOSE_WITH_LOADER: {
      return new Promise((resolve, reject) => {  
        anime({
          targets: content,
          opacity: 0,
          duration: 250,
          easing: 'easeInOutExpo',
          complete: () => {
            anime({
              targets: loadContent,
              opacity: 1,
              duration: 250,
              complete: () => {
                resolve()
              }
            })
          }
        })
      })
    }

    case OPEN: {
      return new Promise((resolve) => {
        anime({
          targets: [...content, ...circle],
          easing: 'easeInOutExpo',
          opacity: [0, 1],
          duration: 500,
          complete: () => {
            resolve()
          }
        })
      })
    }

    case CLOSE: {
      return new Promise((resolve) => {
        anime({
          targets: content,
          easing: 'easeInOutExpo',
          opacity: [1, 0],
          duration: 250,
          complete: () => {
            anime({
              targets: circle,
              easing: 'easeInOutExpo',
              scale: 0,
              duration: 250,
              complete: () => resolve()
            })
          }
        })
      })
    }

    default: {
      return new Promise((resolve) => resolve())
    }
  }
  
}

export {
  animate
}